import { Box, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ArrowForwardIos } from '@mui/icons-material';
import { providerPatientRoute } from '@uplift/constants';
import { Link } from 'react-router-dom';


const useStyles = makeStyles()({
  icon: {
    fontSize: '14px',
  }
});


export const ActionCell: React.FC<{ value?: string }> = ({ value }) => {
  const { classes } = useStyles();

  return (
    <Box display="flex" alignItems="center">
      <IconButton component={Link} to={providerPatientRoute.createLink({ patientId: value })}>
        <ArrowForwardIos className={classes.icon} />
      </IconButton>
    </Box>
  );
};
